import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';

function clp(n) {
  return `$${Number(n || 0).toLocaleString('es-CL')}`;
}

export default function PortalPage() {
  const { cid } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!cid) return;
    localStorage.setItem('gc_condominio_id', cid);
    api
      .get(`/gastos-comunes/condominios/${cid}/portal`)
      .then((r) => setData(r.data))
      .catch((e) => setError(e.response?.data?.error || e.message));
  }, [cid]);

  const descargarInformePdf = async () => {
    const inf = data?.informePublicado;
    if (!inf) return;
    const periodo = `${inf.anio}-${inf.mes}`;
    const { data: blob } = await api.get(`/gastos-comunes/condominios/${cid}/reportes/mensual/pdf`, {
      params: { periodo },
      responseType: 'blob'
    });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank', 'noopener');
  };

  const snap = data?.informePublicado?.snapshot;

  return (
    <>
      <div className="page-header">
        <h2>Portal — informe comunitario</h2>
        <p>Misma vista para comité y propietarios: ingresos, egresos y morosos del último informe publicado.</p>
      </div>
      {error && <div className="alert alert-error">{error}</div>}

      {!data?.informePublicado && !error && (
        <div className="alert alert-info">Aún no hay informe publicado para este condominio.</div>
      )}

      {snap && (
        <div className="card">
          <div className="form-row" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <h3 className="card-title" style={{ margin: 0 }}>
                {snap.periodo?.label}
              </h3>
              <p style={{ color: 'var(--gc-muted)', margin: '4px 0 0' }}>
                Publicado {data.informePublicado.publicadoAt ? new Date(data.informePublicado.publicadoAt).toLocaleString('es-CL') : ''}
              </p>
            </div>
            <button type="button" className="btn secondary" onClick={descargarInformePdf}>
              Descargar PDF
            </button>
          </div>
          <div className="stat-grid">
            <div className="stat-card">
              <span className="stat-label">Ingresos</span>
              <strong>{clp(snap.resumen?.ingresosCaja)}</strong>
            </div>
            <div className="stat-card">
              <span className="stat-label">Egresos</span>
              <strong>{clp(snap.resumen?.egresosPagados)}</strong>
            </div>
            <div className="stat-card">
              <span className="stat-label">Flujo neto</span>
              <strong>{clp(snap.resumen?.flujoNeto)}</strong>
            </div>
          </div>
          <h4>Morosos</h4>
          <div className="table-wrap">
            <table className="data-table appsheet-table">
              <thead>
                <tr>
                  <th>Depto</th>
                  <th>Nombre</th>
                  <th>Monto</th>
                </tr>
              </thead>
              <tbody>
                {(snap.morosos || []).map((m) => (
                  <tr key={m.unidadId}>
                    <td>{m.codigoDepto}</td>
                    <td>{m.nombre}</td>
                    <td>{clp(m.monto)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {data?.misUnidades?.length > 0 && (
        <div className="card">
          <h3 className="card-title">{data.esPropietario ? 'Mi departamento' : 'Mis unidades / consulta'}</h3>
          {data.misUnidades.map((u) => (
            <div key={u.unidadId} className="portal-unidad-block">
              <strong>Depto {u.codigoDepto}</strong>
              <span className={`estado-pill estado-${u.estadoMes}`}>{u.estadoMes}</span>
              <div>
                Total a pagar: {clp(u.totalPagar)} · Deuda vencida: {clp(u.deudaVencida)}
              </div>
              {u.pagosRecientes?.length > 0 && (
                <ul className="ficha-list">
                  {u.pagosRecientes.slice(0, 5).map((p) => (
                    <li key={p.id}>
                      Recibo {p.folioNum} — {clp(p.importe)}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
}
